import { render, staticRenderFns } from "./OssMultiUploadSingle.vue?vue&type=template&id=06fcf105"
import script from "./OssMultiUploadSingle.vue?vue&type=script&lang=js"
export * from "./OssMultiUploadSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports